module.exports = __webpack_public_path__ + "img/product-card-kr.282e8fa.png";